import React, { useEffect, useState } from 'react';
import { scrollToTop } from '@homamo/meadow-utils';

import API, { handleApiError } from '../../../lib/api';
import OnboardingView from './View';
import Loading from '../../common/Loading';
import { useAuth } from '../../../context/auth';
import { getInitialStep } from './steps';

function OnboardingContainer() {
  const [selectedStep, setSelectedStep] = React.useState('start');
  const { user, isCheckingAuth, onUpdateUser } = useAuth();
  // Data state to store the users data. Its initial value is an empty array
  const [mortgageData, setMortgageData] = useState({});
  const [displayError, setDisplayError] = React.useState();
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    const mortgageId =
      user.mortgage_ids && user.mortgage_ids.length && user.mortgage_ids[0];

    if (mortgageId) {
      await API.get(`mortgages/${mortgageId}`)
        .then((res) => {
          setMortgageData(res.data);
        })
        .catch((error) => {
          handleApiError({ error, setDisplayError });
        })
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!mortgageData._id) {
      return;
    }
    const initialStep = getInitialStep({ mortgage: mortgageData, user });
    setSelectedStep(initialStep);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mortgageData._id]);

  if (isCheckingAuth || isLoading) return <Loading />;

  return (
    <OnboardingView
      user={user}
      mortgageId={mortgageData._id}
      mortgage={mortgageData}
      selectedStep={selectedStep}
      setSelectedStep={(newView) => {
        setDisplayError();
        setSelectedStep(newView);
        scrollToTop();
      }}
      displayError={displayError}
      setDisplayError={setDisplayError}
      fetchData={fetchData}
      setMortgageData={setMortgageData}
      setUserData={onUpdateUser}
    />
  );
}

export default OnboardingContainer;
